import { Section } from "../../../../patterns/Section.js";
import type { PageLayoutProps } from "../../../contract.js";
import type { BattleRoomContent } from "../../battlesContent.js";

/**
 * One battle, showroom layout: the head and its info bar, then what
 * the battle is doing (the seats before it starts, the reels while it runs, the outcome once
 * decided), the results under it and the fairness inputs last. One column on every width; the
 * reels and the results lay their seats out to fit.
 */
export function BattleRoomShowroomLayout({ sections }: PageLayoutProps<BattleRoomContent>) {
  return (
    <Section className="flex flex-col gap-6 pt-6 pb-20 md:gap-8 md:pt-10">
      {sections.header}
      {sections.notice}
      {sections.seats}
      {sections.stage}
      {sections.outcome}
      {sections.results}
      {sections.fairness}
    </Section>
  );
}
